// Yangın sınıfı parametreleri - Excel'den alınan doğru veriler
const parameterData = [
  {
    id: 1,
    code: 'wooden-stack', // Excel'de "Ahşap Deste" - genel kullanım için
    fire_class: 'A',
    material: 'Ahşap Deste',
    material_en: 'Wood Crib Fire Test',
    en_test_number: 'A.6.1',
    iso_test_number: 'D.6.1',
    density: 62.00, // Excel: 62
    density_unit: 'gram/m³'
  },
  {
    id: 2,
    code: 'a-wooden-stack',
    fire_class: 'A',
    material: 'A Sınıfı Ahşap Deste',
    material_en: 'Class A Compatible Wood Crib Test',
    en_test_number: 'A.6.4',
    iso_test_number: 'D.6.4',
    density: 49.75, // Excel: 49.75
    density_unit: 'gram/m³'
  },
  {
    id: 3,
    code: 'a-polymer-sheet',
    fire_class: 'A',
    material: 'Polimer Levha (ABS, Polipropilen, PMMA)',
    material_en: 'Polymeric Sheet Fire Test',
    en_test_number: 'A.6.3',
    iso_test_number: 'D.6.3',
    density: 49.39, // Excel: 49.39
    density_unit: 'gram/m³'
  },
  {
    id: 4,
    code: 'b-nheptane-liquid',
    fire_class: 'B',
    material: 'B Sınıfı N-Heptan Sıvı',
    material_en: 'N-Heptane Pan Fire Test',
    en_test_number: 'A.6.2',
    iso_test_number: 'D.6.2',
    density: 74.89, // Excel: 74.89
    density_unit: 'gram/m³'
  }
];

// Parametre ID'sine göre parametre verilerini döndüren yardımcı fonksiyon
export const getParameterById = (parameterId) => {
  const id = parseInt(parameterId);
  return parameterData.find(parameter => parameter.id === id) || null;
};

// Parametre koduna göre parametre verilerini döndüren yardımcı fonksiyon
export const getParameterByCode = (code) => {
  return parameterData.find(parameter => parameter.code === code) || null;
};

// Tüm parametre verilerini döndüren fonksiyon
export const getAllParameters = () => {
  return parameterData;
};

// Belirli bir yangın sınıfına ait parametreleri döndüren fonksiyon
export const getParametersByFireClass = (fireClass) => {
  return parameterData.filter(parameter => parameter.fire_class === fireClass);
};

// Parametre koduna göre parametre verilerini döndüren fonksiyon
export const getDensityByCode = (code) => {
  const parameter = getParameterByCode(code);
  return parameter ? parameter.density : 49.75; // Varsayılan olarak A Sınıfı Ahşap Deste değerini döndür
};

export default parameterData; 